import styled from "styled-components"
import AvenueImg from "UI/AvenueImg"
import { device } from "breakpoints"
import { Button, StyledLink } from "UI"

export const WhiteTeaseImage = styled(AvenueImg)`
  width: 100%;
  position: relative;
`
export const FullWidthLink = styled(StyledLink)`
  position: static;

  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: none;
  }
`
export const TeaserContainer = styled.div`
  box-shadow: 0px 5px 35px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  background: white;
  position: relative;
  display: grid;
  grid-template-rows: auto 1fr;
  width: 278px;
  flex-shrink: 0;
  position: relative;
  border-bottom: 5px solid #008cd1;
  overflow: hidden;

  @media ${device.tablet} {
    width: 100%;
    grid-template-rows: auto 1fr;
  }
  @media ${device.desktop} {
    grid-template-rows: auto 1fr;
  }
`
export const CustomContentGrid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: scroll;
  -webkit-overflow-scrolling: auto;
  gap: 20px;
  margin-left: -20px;
  padding-left: 20px;
  margin-right: -20px;
  padding-right: 20px;
  padding-bottom: 30px;
  margin-bottom: 18px;

  @media ${device.tablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    flex-wrap: wrap;
    overflow-x: visible;
    margin-left: unset;
    padding-left: unset;
    margin-right: unset;
    padding-right: unset;
    padding-bottom: 35px;
    margin-bottom: 25px;
  }
  @media ${device.desktop} {
    grid-template-columns: repeat(${(props) => props.numberOfItems}, 275px);
    justify-content: center;
  }

  /* Webkit browsers */
  ::-webkit-scrollbar {
    height: 8px;
    margin-left: 20px;
    display: flex;
    justify-content: center;
  }
  ::-webkit-scrollbar-track {
    background: rgba(159, 229, 255, 0.3);
    border-radius: 10px;
    margin-right: 20px;
    margin-left: 20px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #47c5f3;
    border-radius: 10px;
    width: 20%;
  }

  /* Firefox */
  scrollbar {
    height: 8px;
    margin-left: 20px;
    display: flex;
    justify-content: center;
  }
  scrollbar track {
    background: rgba(159, 229, 255, 0.3);
    border-radius: 10px;
    margin-right: 20px;
    margin-left: 20px;
  }
  scrollbar thumb {
    background-color: #47c5f3;
    border-radius: 10px;
    width: 20%;
  }
`

export const ContentCardsButton = styled(Button)`
  align-self: center;
  span {
    font-size: 16px;
  }
  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: none;
    z-index: 1;
  }
`

export const HeaderWrapper = styled.div`
  border-top: 5px solid #f5f5f5;
  padding-top: 24px;
  margin-bottom: 24px;
  @media ${device.desktop} {
    margin-top: 60px;
    padding-top: 53px;
    margin-bottom: 48px;
  }
`
